<template>
    <div id="app">
        <b-overlay :show="isActive" rounded="lg">
            <router-view></router-view>
        </b-overlay>
    </div>
</template>

<script>
import Bus from "./configs/bus";

export default {
    name: "app",
    data() {
        return {
            bus: Bus,
            isActive: false
        };
    },
    mounted() {
        const vm = this;
        vm.bus.$on("toggle", () => {
            vm.isActive = !vm.isActive;
        });
    }
};
</script>

<style>
html {
    background-color: #ddcecb;
}

#app {
    background-color: #ddcecb;
}
</style>
